import { mixins, styled } from '@pulse-web-ui/theme';

export const SettingsWrapper = styled.div`
  ${mixins.flex({ justifyContent: 'space-between', alignItems: 'center' })}
`;
